export type PulseGreetingPeriod = "morning" | "afternoon" | "evening";

export const getPulseGreetingPeriod = (date: Date = new Date()): PulseGreetingPeriod => {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return "morning";
  }

  if (hour >= 12 && hour < 18) {
    return "afternoon";
  }

  return "evening";
};
